<ngx-charts-advanced-pie-chart 
    [view]="view" 
    [scheme]="colorScheme" 
    [results]="pieData" 
    (select)="onSelect($event)">
</ngx-charts-advanced-pie-chart>